if ( pplang == 'pt') {


    //Notices =
    var locale = 'pt';
    var helpurl = 'https://ultrapassport.com/ajuda/';
    var _lwidth = '3em';


    var _globalnotice = `Os Ingressos para o ${regname} estarão à venda amanha`;
    var _globalnoticereg = 'Confira seu email! Nós mandamos as intruções de compra do ingresso.';
    var _maintenance = 'Ultra Passport está indisponível no momento, tente novamente mais tarde.';
    var _guestnotice = 'É necessário estar logado para ver está página.';

    //Labels =
    var _fullname = 'Nome Completo';
    var _firstname = 'Primeiro Nome';
    var _lastname = 'Sobrenome';
    var _email = 'Email';
    var _emailaddy = 'Endereço de email';
    var _confirmemailaddy = 'Confirm Email Address';
    var _birthday = 'Data de Nascimento';
    var _location = 'Local de Nascimento';
    var _country = 'País';
    var _homeevent = 'Evento de seu interesse';
    var _gender = 'Sexo';
    var _password = 'Senha';
    var _male = 'Masculino';
    var _female = 'Feminino';
    var _pleaseselect = 'Selecione';
    var _signuptitle = 'Ultra Passport Cadastro';
    var _enteryouremail = 'Preencha seu endereço de Email';
    var _backtologin = 'Entrar Novamente';
    var _requestnewpass = 'Solicitar Troca de Senha';
    var _on = 'Ligado';
    var _off = 'Desligado';
    var _enrollmentavailable = 'Inscrições disponíveis agora';

    //Text =
    var _logintext = 'Entrar';
    var _password = 'Senha';
    var _welcome = 'Bem-Vindo';
    var _account = 'Conta';
    var _myaccount = 'Minha Conta';
    var _mypassport = 'Minha Passport';
    var _events = 'Eventos';
    var _points = 'Pontos';
    var _updates = 'Updates';
    var _signout = 'Sair';
    var _signin = 'Entrar';
    var _signedin = 'Assinado';
    var _signuptext = 'Cadastrar-se';
    var _nextlevel = 'Proximo nível';
    var _forgot = 'Esqueceu sua senha?';
    var _subscribed = 'Inscrito';
    var _helpcenter = 'Centro de ajuda';
    var _error = 'Erro';
    var _silver = 'Prata';
    var _gold = 'Ouro';
    var _platinum = 'Platinum';

    //Validation =
    var _gendertext = 'É necessário escolher um sexo';
    var _accepttext = 'É necessário aceitar os termos';


    //Email Verifications =
    var _resendverify = 'Reenviar confirmação de email';
    var _revalidate = 'Cheque seu email para validar sua conta';
    var _sendingverification = 'Enviando verificação de email...';
    var _verifysent = 'Verificação enviada';
    var _emailverifydashboard = 'Não esqueça de confimar seu email para ter acesso a updates e cadastro de ingressos';
    var _emailverifyupdates = 'Não esqueça de confirmar seu email para receber updates';


    //Edit =
    var _editaccount = 'Editar Conta';
    var _nochanges = 'Nenhuma edição detectada';
    var _accountupdated = 'Conta atualizada';
    var _emailupdatedstarted = 'Novo email precisa ser verificado, confira seu email.';
    var _emailupdatedverified = 'Seu novo email esta verificado';
    var _passwordresetsent = 'Email para troca de senha enviado';


    //Footer =
    var _startinput = 'Preencha seu email para começar...';
    var _starttext = 'Não tem uma conta? Cadastre-se para estar elegível <br class ="small-hide">à eventos, pontos e mais!';
    var _getstarted = 'Comece Aqui';


    //Signup =
    var _createaccount = 'Criar Minha Conta';
    var _almost = 'Quase Lá...';
    var _almost2 = 'Parabéns $user_firstname, você criou sua conta Ultra Passport! <span class="tm">™</span>';
    var _almost3 = 'Para ativar sua conta <strong><u>é ncessário verificar seu email</u></strong> clicando no link de confirmação que enviamos ao seu <strong>$user_email</strong>..';
    var _almost4 = 'Caso não tenha recebido nenhum email <strong><u>confira sua pasta de spam</u></strong> e inclua <strong><u><a href="mailto:info@e.ultrapassport.com">info@e.ultrapassport.com</a></u></strong> a seus <strong><u>contatos confiavéis</u></strong>';
    var _almost5 = 'Prosseguir';
    var _createdsuccess = 'Conta Criada';
    var _createdinfo = 'Sua Conta esta sendo criada:';
    var _accountactivated = 'Sua Conta foi ativada';
    var _accountverified = 'Seu email foi verificado.';
    var _passwordresetsuccess = 'Troca de Senha com sucesso';


    //Updates =
    var _updatestext1 = 'É necessário entrar para se registrar e receber updates.';
    var _updatestextPending = 'Por favor verifique seu endereço de email para receber updates.';
    var _updatessubsrcibe = 'Você está inscrito para receber updates do:';
    var _updatesunsubsrcibe = 'Você cancelou a inscrição para receber updates do:';


    //Registration =
    var _rbtnbuy = 'Compre Ingressos agora';
    var _regbuy = 'Compre Ingressos';
    var _rbtnregister = 'Registro para Ingressos';
    var _rbtnclosed = 'Fechado';
    var _rbtnsoon = 'Em Breve';
    var _rbtnupdates = 'Receber Updates';
    var _verifyemailregister = 'É necessário verificar seu email antes de se registrar';
    var _regbtnhtml = 'Registrado';
    var _regerror = 'Erro!';
    var _regerror2 = 'Por favor tente novamente';
    var _regprocessing = 'Seu Registro está sendo processado...';
    var _registersuccess = 'Registro feito com sucesso.';
    var _regaccepted = 'Seu <u class="regtype"></u> registro foi aceito no';
    var _regaccepted2 = 'Instruções de compra são enviadas ao seu email entra 24-48 horas antes do início das vendas.';
    var _regdone1 = 'Código de registro';
    var _regdone2 = 'Você se registrou em';
    var _regdone3 = 'Reenviar instruções de compra';

    //Registrations =
    var _regtext1 = 'Suas Informações estão atualizadas?';
    var _regtext2 = 'Por Favor confirme sua informação de registro para';
    var _regguest1 = 'É necessario estar logado para registrar à eventos';
    var _regpending1 = 'Quase lá!';
    var _regpending2 = 'Por favor confirme sua <strong>conta de email</strong> para liberar o cadastro.';
    var _updateinfobtn = 'Atualizar Minhas Informações';
    var _confirmreg = 'Confirme Meu Registro';


    // Privacy / Terms Notice =
    var privacytext = 'Política de Privacidade';
    var termsofuse = 'Termos de Uso';
    var upptextlogo = 'Ultra Passport<span class="tm">&trade;</span>';
    var privacylink = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${privacytext}</a>`;
    var termslink = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${termsofuse}</a>`;
    var _agreesignup = `Eu concordo com os ${termslink} e a ${privacylink} no ${upptextlogo}`;
    var _agreesignup2 = `Ao Cadastrar, você concorda com os ${termslink} e a ${privacylink} do ${upptextlogo}`;
    var _agreeregister = `Ao Registrar, você concorda com os ${termslink} e a ${privacylink} do ${upptextlogo}`;


  // Passport Labels
    _action = 'Ação',
    _award = 'Prêmio',
    _benefit = 'Benefício',
    _pointsexpire = '*OS PONTOS EXPIRAM APÓS 25 MESES ',
    _qualifydisclaimer = '*ATENÇÃO O "FULL ULTRA FESTIVAL" NÃO INCLUI O ROAD TO ULTRA, ULTRA BEACH E OS EVENTOS RESISTANCE.',

    _howtoqualify = 'Como se Registrar',

    _btn_dashboard = 'Página Inicial',
    _btn_benefits = 'Benefícios',
    _btn_qualify = 'Registre-se',
    _btn_points = 'Meus Pontos',

    leveltext = _silver,
    nextlevel = _gold;


    var _birthdayselect = '<div class="datefield"><span class="subfield dayfield"><select class="required" id="birthday" name="birthday" style="width:80px;display:inline-block" data-field="birthday"><option value="" disabled selected>DD</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option><option value="30">30</option><option value="31">31</option></select></span><span class="spacer">/</span> <span class="subfield monthfield"><select class="required" id="birthmonth" name="birthmonth" style="width:80px;display:inline-block"><option value="" disabled selected>MM</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option></select></span><span class="spacer">/</span> <span class="subfield yearfield"><select class="required" id="birthyear" name="birthyear" style="width:100px;display:inline-block"><option disabled selected>YYYY</option><option value="2017">2017</option><option value="2016">2016</option><option value="2015">2015</option><option value="2013">2013</option><option value="2012">2012</option><option value="2011">2011</option><option value="2010">2010</option><option value="2009">2009</option><option value="2008">2008</option><option value="2007">2007</option><option value="2006">2006</option><option value="2005">2005</option><option value="2004">2004</option><option value="2003">2003</option><option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option><option value="1936">1936</option><option value="1935">1935</option><option value="1934">1934</option><option value="1933">1933</option><option value="1932">1932</option><option value="1931">1931</option><option value="1930">1930</option><option value="1929">1929</option><option value="1928">1928</option><option value="1927">1927</option><option value="1926">1926</option><option value="1925">1925</option><option value="1924">1924</option><option value="1923">1923</option><option value="1922">1922</option><option value="1921">1921</option><option value="1920">1920</option><option value="1919">1919</option><option value="1918">1918</option><option value="1917">1917</option><option value="1916">1916</option><option value="1915">1915</option><option value="1914">1914</option><option value="1913">1913</option><option value="1912">1912</option><option value="1911">1911</option><option value="1910">1910</option><option value="1909">1909</option><option value="1908">1908</option><option value="1907">1907</option><option value="1906">1906</option><option value="1905">1905</option><option value="1904">1904</option><option value="1903">1903</option><option value="1902">1902</option><option value="1901">1901</option><option value="1900">1900</option></select></span></div>';

    // Errors =
    var errors = {
        reset : 'Email inválido ou token expirado.',
        create : 'Criação sem sucesso, por favor tente novamente.',
        general : 'Oops! Algo deu errado. Por favor confira se os cookies estçao permitidos.',
        password : 'Senha deve conter no mínimo 8 caracteres.',
        duplicateemail : 'Conta de email já está em uso.',
        matchemail : 'Your email addresses don\'t match. Please confirm and reenter your email address.',
        loginfail : 'O nome de usuário e a senha digitados não correspondem aos nossos registros.',
        token : 'Token Inválido',
        birthday : "You must be 16 years of age or older to enroll in Ultra Passport.",
    }

    // Point Labels
    var pointcodes = {
        manual : 'Passport Admin',
        unknown : 'Ajuste del Administrador de Pasaportes',
        verify : 'Conta de Email Verificada',
        attend_festival : 'Vá ao Full Ultra Festival',
        attend_rtu : 'Attend a Road to Ultra Event',
        attend_resistance : 'Attend a Resistance Only Event',
        away_bonus : 'Vá a um Evento em Outro Continente',
        home_bonus_1 : 'Vá ao Evento no seu País',
        home_bonus_2 : 'Vá ao Evento no seu País x2',
        home_bonus_3 : 'Vá ao Evento no seu País x3'
    };

}
